module.exports = __webpack_public_path__ + "media/assets/icons/arrow-big-6975442d30f66b0eb97ba41b3281eb76.svg";